import { UNIFIED_DASHBOARD_PATH } from "./productRouteMap";

const matchPath = (pathname, path) => {
  if (!path) return false;
  if (path.includes(":")) {
    return pathname.startsWith(path.split(":")[0]);
  }
  return pathname === path || pathname.startsWith(`${path}/`);
};

const buildTab = (label, path, pathname, isDisabled = false) => ({
  id: path,
  label,
  path,
  isActive: matchPath(pathname, path),
  isDisabled,
});

export const getProductKeyFromPathname = (pathname) => {
  if (pathname.startsWith("/jarvis-portfolio")) return "portfolio";
  if (pathname.startsWith("/jarvis-prime")) return "prime";
  if (pathname.startsWith("/jarvis-rms")) return "rms";
  if (pathname.startsWith("/jarvis-onestock")) return "onestock";
  if (pathname.startsWith("/sentiment-tracker")) return "sentiment";
  if (pathname.startsWith("/phc")) return "phc";
  return null;
};

export const isProductDeepRoute = (pathname) => {
  const key = getProductKeyFromPathname(pathname);
  if (!key) return false;
  return !pathname.includes("/onboarding");
};

export const getProductTopNavConfig = (pathname, onboardingFlags = {}) => {
  const {
    isOnboardingCompleted,
    isRMSOnboardingCompleted,
    isOnestockOnboardingCompleted,
    isPrimeOnboardingCompleted,
    isSentimentTrackerOnboardingCompleted,
    isPHCOnboardingCompleted,
  } = onboardingFlags;

  const productKey = getProductKeyFromPathname(pathname);
  if (!productKey || pathname.includes("/onboarding")) {
    return null;
  }

  switch (productKey) {
    case "portfolio":
      return {
        productLabel: "Portfolio",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab(
            "Dashboard",
            "/jarvis-portfolio/dashboard",
            pathname,
          ),
          buildTab(
            "Holdings",
            "/jarvis-portfolio/existing-holding",
            pathname,
            !isOnboardingCompleted,
          ),
          buildTab(
            "Action Centre",
            "/jarvis-portfolio/action-centre",
            pathname,
            !isOnboardingCompleted,
          ),
          buildTab(
            "Invest More",
            "/jarvis-portfolio/invest-more",
            pathname,
            !isOnboardingCompleted,
          ),
          buildTab(
            "Transactions",
            "/jarvis-portfolio/transactions",
            pathname,
            !isOnboardingCompleted,
          ),
        ],
      };
    case "prime":
      return {
        productLabel: "Prime",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab("Dashboard", "/jarvis-prime/dashboard", pathname),
          buildTab(
            "Holdings",
            "/jarvis-prime/existing-holding",
            pathname,
            !isPrimeOnboardingCompleted,
          ),
          buildTab(
            "Action Centre",
            "/jarvis-prime/action-centre",
            pathname,
            !isPrimeOnboardingCompleted,
          ),
          buildTab(
            "Invest More",
            "/jarvis-prime/invest-more",
            pathname,
            !isPrimeOnboardingCompleted,
          ),
          buildTab(
            "Transactions",
            "/jarvis-prime/transactions",
            pathname,
            !isPrimeOnboardingCompleted,
          ),
        ],
      };
    case "rms":
      return {
        productLabel: "Protect",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab("Dashboard", "/jarvis-rms/dashboard", pathname),
          buildTab(
            "Holdings",
            "/jarvis-rms/existing-holding",
            pathname,
            !isRMSOnboardingCompleted,
          ),
          buildTab(
            "Action Centre",
            "/jarvis-rms/action-centre",
            pathname,
            !isRMSOnboardingCompleted,
          ),
          buildTab(
            "Transactions",
            "/jarvis-rms/transactions",
            pathname,
            !isRMSOnboardingCompleted,
          ),
        ],
      };
    case "onestock":
      return {
        productLabel: "One Stock",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab("Dashboard", "/jarvis-onestock/dashboard", pathname),
          buildTab(
            "Holdings",
            "/jarvis-onestock/existing-holding",
            pathname,
            !isOnestockOnboardingCompleted,
          ),
          buildTab(
            "Action Centre",
            "/jarvis-onestock/action-centre",
            pathname,
            !isOnestockOnboardingCompleted,
          ),
          buildTab(
            "Transactions",
            "/jarvis-onestock/transactions",
            pathname,
            !isOnestockOnboardingCompleted,
          ),
        ],
      };
    case "sentiment":
      return {
        productLabel: "Sentiment",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab(
            "Dashboard",
            "/sentiment-tracker/dashboard",
            pathname,
          ),
        ],
      };
    case "phc":
      return {
        productLabel: "PHC",
        explorePath: UNIFIED_DASHBOARD_PATH,
        tabs: [
          buildTab("Dashboard", "/phc/dashboard", pathname),
        ],
      };
    default:
      return null;
  }
};
